import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { TranslatePipe } from '../../pipes/translate.pipe';
import { AppLanguage } from '../../i18n/app-translations';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-language-switch',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './language-switch.component.html',
  styleUrl: './language-switch.component.css'
})
export class LanguageSwitchComponent {
  @Input() compact = false;

  constructor(private readonly language: LanguageService) {}

  get currentLanguage(): AppLanguage {
    return this.language.currentLanguage;
  }

  setLanguage(language: AppLanguage): void {
    this.language.setLanguage(language);
  }
}
